import React from 'react';
import {VendorSolutionProvider} from '../vendor-solution-provider'
import VendorSolutionSettingContainer from './vendor-solution-setting-container'

const VendorSolutionSetting = props => {

  return (
    <VendorSolutionProvider>
      <VendorSolutionSettingContainer {...props} />
    </VendorSolutionProvider>
  );
};

export default VendorSolutionSetting;
